module.exports = __webpack_public_path__ + "img/svg/step4.b3a12ec33cc21d7ff8ccab59c8e5767a.svg";